import React, { useState } from 'react'
import './CheckinForm.css'
import { Form } from 'antd'
import dayjs from 'dayjs'

// Import step components
import OtpCapture from './steps/otp-capture'
import VisitReason from './steps/visit-reason'
import SymptomsCapture from './steps/symptoms-capture'
import InjuryCapture from './steps/injury-capture'
import BasicInfo from './steps/basic-info' // Renamed to BasicInfo
import Completion from './steps/completion'

const CheckinForm = () => {
  const [currentStep, setCurrentStep] = useState(1)
  const [form] = Form.useForm()
  const [pickerValue, setPickerValue] = useState(undefined)
  const [bookingData, setBookingData] = useState(null)

  const [formData, setFormData] = useState({
    otp: '',
    bookingId: '',
    patientRecord: {},
    visitType: '',
    symptoms: [],
    additionalSymptoms: '',
    injuries: [],
    basicInfo: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      physicalAddress: '',
      dateOfBirth: null,
      medicalAid: {
        name: '',
        schemeCode: '',
        plan: '',
        planCode: '',
        planOption: '',
        planOptionCode: '',
        number: '',
        dependantNumber: ''
      }
    }
  })

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <OtpCapture
            formData={formData}
            setFormData={setFormData}
            setCurrentStep={setCurrentStep}
            form={form}
            setBookingData={setBookingData}
            setPickerValue={setPickerValue}
          />
        )

      case 2:
        return <VisitReason formData={formData} setFormData={setFormData} setCurrentStep={setCurrentStep} />

      case 3:
        return formData.visitType === 'sick' ? (
          <SymptomsCapture formData={formData} setFormData={setFormData} setCurrentStep={setCurrentStep} />
        ) : (
          <InjuryCapture formData={formData} setFormData={setFormData} setCurrentStep={setCurrentStep} />
        )

      case 4:
        return (
          <BasicInfo
            formData={formData}
            setFormData={setFormData}
            setCurrentStep={setCurrentStep}
            form={form}
            bookingData={bookingData}
            pickerValue={pickerValue}
            setPickerValue={setPickerValue}
          />
        )

      case 5:
        return <Completion />

      default:
        return null
    }
  }

  return (
    <div className='checkin-container'>
      <div className='progress-bar'>
        <div className='progress' style={{ width: `${(currentStep / 5) * 100}%` }}></div>
      </div>
      {renderStep()}
    </div>
  )
}

export default CheckinForm
